import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
 selector: 'formly-field-textarea',
 template: `
   <textarea  class="form-control" [formControl]="formControl" [formlyAttributes]="field" rows="2"></textarea>
 `,
})export class FormlyFieldTextarea extends FieldType {
  ngOnInit(){
    this
  }
}